<template>
    <div class="contenedor" id="contenedor">
        <div class="divFiltro">
            <p><b-icon icon="funnel"></b-icon> Filtros</p>
        </div>
        <div class="menu">
            <b-navbar-brand>Proyectos</b-navbar-brand>
            <b-nav class="item">
                <b-form-group v-slot="{ ariaDescribedby }">
                    <b-form-checkbox-group id="checkbox-group-1" v-model="filter.projects" :options="projects"
                        :aria-describedby="ariaDescribedby" name="flavour-1" stacked>
                    </b-form-checkbox-group>
                </b-form-group>
            </b-nav>

            <b-navbar-brand>Niveles</b-navbar-brand>
            <b-nav class="item">
                <b-form-group v-slot="{ ariaDescribedby }">
                    <b-form-checkbox-group id="checkbox-group-3" v-model="filter.levels" :options="levels"
                        :aria-describedby="ariaDescribedby" name="flavour-3" stacked>
                    </b-form-checkbox-group>
                </b-form-group>
            </b-nav>
        </div>
    </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import "flatpickr/dist/themes/material_blue.css";
import { Spanish } from "flatpickr/dist/l10n/es.js";
export default {
    components: {
        flatPickr,
    },
    data() {
        return {
            filter: {
                projects: [],
                date: {
                    start: null,
                    end: null,
                },
                levels: [],
            },
            // selected: [],
            projects: [
                // { text: 'Todos', value: 'allProjects' },
                { text: 'Aciqui-Web', value: 'Web' },
                { text: 'Aciqui-Android', value: 'Android' },
                { text: 'Aciqui-iOS', value: 'iOS' },
                { text: 'Persistencia', value: 'Persistencia' },
                { text: 'Asíncrona', value: 'Asincrona' },
            ],
            levels: [
                // { text: 'Todos', value: 'allLevels' },
                { text: 'Warning', value: 'Warning' },
                { text: 'Critical', value: 'Critical' },
                { text: 'Error', value: 'Error' },
            ],
            // time:
            rangoFechas: null,
            configDateRange: {
                wrap: true,
                altFormat: "M j, Y",
                altInput: true,
                dateFormat: "Y-m-d",
                minDate: new Date().fp_incr(-30),
                maxDate: new Date(),
                mode: "range",
                locale: Spanish,
                static: true,
                // inline: true,
            },
        }
    },
    mounted() {
    },
    watch: {
        filter: {
            handler(newFilter) {
                this.$emit('updateFilter', newFilter);
            },
            deep: true,
        },
        rangoFechas: function (newDate) {
            if (newDate !== null) {
                this.setDates(newDate);
            }
        }
    },
    methods: {
        resetDates() {
            this.filter.date.start = null;
            this.filter.date.end = null;
            this.rangoFechas = null;
        },
        setDates(date) {
            const myArr = date.split(" ");
            this.filter.date.start = myArr[0];
            if (myArr.length > 2) {
                this.filter.date.end = myArr[2];
            } else {
                this.filter.date.end = this.filter.date.start;
            }
        },
    }
}
</script>

<style scoped>
.contenedor {
    background-color: #343D54;
    box-shadow: none;
    border-radius: 10px;
    padding-left: 15px;
}

.divFiltro {
    padding-top: 25px;
    margin-bottom: -15px;
    color: white;
    font-size: 18px;
}

.navbar-brand {
    color: #bfd675 !important;
    font-weight: 450;
    font-size: 16px;

}

.item {
    color: white;
    margin-left: 10px !important;
}

/* TODO: ver la forma de no afectar los demas inputs */
.custom-checkbox .custom-control-input:checked~.custom-control-label::before {
    background-color: #1D2641 !important;
    border: 2px solid #bfd675;

}

.custom-checkbox .custom-control-label::before {
    background-color: #1D2641;
    width: 1em;
    height: 1em;
}

.flatpickr-wrapper {
    width: 94%;
}

.datepicker-container>.form-control,
.form-control:focus,
.form-control {
    background-color: white;
    border: 2px solid #bfd675 !important;
}
</style>